export enum SocialNetworks {
  Vk = 'VK',
  Ok = 'OK',
  Mail = 'MM',
  Facebook = 'FB',
  Google = 'GP',
  Yandex = 'YA',
}

export enum DataQaLocators {
  Vk = 'vk-auth',
  Ok = 'ok-auth',
  Mail = 'mailru-auth',
  Facebook = 'facebook-auth',
  Google = 'google-auth',
  Yandex = 'yandex-auth',
}

export enum SocialNetworkCode {
  Vk = 1,
  Google = 2,
  Mail = 3,
  Ok = 4,
  Facebook = 5,
  Yandex = 6,
}

export enum SocialNetworksErrorCode {
  EmailNotReceived = 1,
  BadRequest = 400,
  InternalServerError = 500,
}

export enum SocialNetworkLabelsGA {
  Vk = 'VK',
  Ok = 'Ok',
  Google = 'Gmail',
  MailRu = 'Mail',
  Yandex = 'Ya',
  Fb = 'Fb',
}
